<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck" filterable
                               @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')">
                    <el-select v-model="strCode" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="houseChange">
                        <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                   :value="house.strCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.locatorName')">
                    <el-select v-model="sppCode" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="sppChange">
                        <el-option v-for="partPosition in partPositionTOList" :key="partPosition.sppId"
                                   :label="partPosition.sppName" :value="partPosition.sppCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.spareCode')">
                    <el-input v-model.trim="spCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareName')">
                    <el-input v-model.trim="spName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareBrand')">
                    <el-input v-model.trim="spBrand" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareModel')">
                    <el-input v-model.trim="spModel" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.currentState')">
                    <el-select v-model="spStatus" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="getAllStock()">
                        <el-option label="库存不足" value="a_insufficient"/>
                        <el-option label="采购中" value="b_purchase"/>
                        <el-option label="库存充足" value="c_normal"/>
                        <el-option label="待定" value="d_bepending"/>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="getAllStock()">{{$t('base.search')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('demo.menu.SpareStock')" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click="exportSparePartStock()">{{$t('base.export')}}</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border :cell-style="rowClass"
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="110"/>
                <el-table-column prop="spName" :label="$t('Account.spareName')" width="110"/>
                <el-table-column prop="spBrand" :label="$t('Account.spareBrand')" width="110"/>
                <el-table-column prop="spModel" :label="$t('Account.spareModel')" width="120"/>
                <el-table-column prop="spLevel" :label="$t('Account.sort')" width="80"/>
                <el-table-column prop="strName" :label="$t('Account.storeName')" width="110"/>
                <el-table-column prop="sppName" :label="$t('Account.locatorName')" width="110" />
                <el-table-column prop="spStatus.desc" :label="$t('Account.currentState')" width="110"/>
                <el-table-column prop="spSafeStock" sortable :label="$t('Account.safetyStock')" width="115"/>
                <el-table-column prop="amount" sortable :label="$t('Account.currentStock')" width="120"/>
                <el-table-column prop="spMaxStock" sortable :label="$t('Account.stockCeil')" width="115"/>
                <el-table-column prop="unit" :label="$t('Account.unit')" width="80"/>
                <el-table-column prop="batchNo" :label="$t('Account.batchNo')"/>
                <el-table-column prop="supplierCode" :label="$t('Account.supplierCode')" width="120"/>
                <el-table-column prop="supplierName" :label="$t('Account.supplierName')" width="120"/>
                <!--<el-table-column prop="spSafeStock" sortable label="安全库存" width="120"/>
            <el-table-column prop="spSurplusStock" sortable label="当前库存" width="120"/>
            <el-table-column prop="spMaxStock" sortable label="库存上限" width="120"/>-->
                <el-table-column :label="$t('base.operation')" width="120" fixed="right">
                    <template slot-scope="scope">
                        <span v-for="acc in access" :key="acc">
                            <i class="document el-icon-truck" @click="allot(scope.row)"
                            v-if="acc == 'SPAREINV001'"/>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="$t('Account.allot')" width="50vw" :visible.sync="allotShow" style="text-align: left">
            <el-form style="margin-top: 3vw" :model="stockOrder" :rules="stock" ref="stock" label-width="120px"
                     class="demo-roleForm">
                <!--<el-form-item label="所属工厂" prop="fcCode">
                <el-select v-model="stockOrder.fcCode" placeholder="请选择工厂" :clearable="isclear" filterable
                           @change="fcChange">
                    <el-option
                        v-for="factory in factoryList"
                        :key="factory.factoryId"
                        :label="factory.fcName"
                        :value="factory.fcCode">
                    </el-option>
                </el-select>
            </el-form-item>-->
                <el-form-item :label="$t('Account.nowLocator')">
                    <el-input v-model="stockOrder.currentSppName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.nowBatchNo')">
                    <el-input v-model="stockOrder.batchNo" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.nowLocatorNum')">
                    <el-input v-model="stockOrder.currentAmount" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.allotNum')" prop="amount">
                    <el-input-number v-model.trim="stockOrder.amount" :min="1" :placeholder="$t('User.input')"
                                     @change="judgeTQua"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')" prop="strCode">
                    <el-select v-model="stockOrder.strCode" :placeholder="$t('User.select')" clearable filterable
                               @change="sparePartPositionList(true)">
                        <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                   :value="house.strCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.locatorName')" prop="sppCode">
                    <el-select v-model="stockOrder.sppCode" :placeholder="$t('base.PleaseSelect')" filterable @change="sppCodeChange">
                        <el-option v-for="partPosition in partPositionList" :key="partPosition.sppId"
                                   :label="partPosition.sppName" :value="partPosition.sppCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="allotShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateStockOrder('stock')">{{$t('base.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { allotStock, exportSparePartStock, getAllStock } from '../../../libs/api'

    export default {
        name: 'sparePartStockOrder',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                factoryList: [],
                houseList: [],
                partPositionList: [],
                partPositionTOList: [],
                allotShow: false,
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                stockOrder: {
                    // fcCode: '',
                    strCode: '',
                    sppCode: '',
                    amount: '',
                    currentSppName: '',
                    currentAmount: '',
                    currentSppCode: '',
                    sptId: '',
                    batchNo: '',
                    batchNoTo: ''
                },
                stock: {
                    /*fcCode: [
                        {
                            type: 'string',
                            required: true,
                            message: '请选择工厂',
                            trigger: 'blur'
                        }
                    ],*/
                    strCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ],
                    sppCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ],
                    amount: [
                        {
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ]
                },
                fcCode: '',
                strCode: '',
                sppCode: '',
                spCode: '',
                spName: '',
                spBrand: '',
                spModel: '',
                spStatus: '',
                access: []
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
            },
            rowClass(row, index) {
                if (row.row.spStatus.code == 'a_insufficient') {
                    return {
                        'background-color': '#ee5253',
                        // 'border-color': '#868686',
                        'color': '#fff'
                    }
                }
                if (row.row.spStatus.code == 'b_purchase') {
                    return {
                        'background-color': '#f1c40f',
                        // 'border-color': '#868686',
                        'color': '#fff'
                    }
                }
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getAllStock()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.getAllStock()
            },
            fcChange() {
                this.stockOrder.strCode = ''
                this.strCode = ''
                this.stockOrder.sppCode = ''
                this.sppCode = ''
                this.partStoreHouseList()
                this.getAllStock()
            },
            houseChange() {
                this.stockOrder.sppCode = ''
                this.sppCode = ''
                this.sparePartPositionList(false)
                this.getAllStock()
            },
            sppChange() {
                this.getAllStock()
            },
            allot(row) {
                if (this.fcCode == undefined || this.fcCode == '') {
                    this.$message.error(this.$t('mechanism.selectFc'))
                    return
                }
                this.stockOrder = {}
                this.partPositionList = []
                this.stockOrder.currentSppName = row.sppName
                this.stockOrder.currentAmount = row.amount
                this.stockOrder.currentSppCode = row.sppCode
                this.stockOrder.sptId = row.sptId
                this.stockOrder.batchNo = row.batchNo
                this.allotShow = true
            },
            judgeTQua() {
                if (this.stockOrder.amount > this.stockOrder.currentAmount) {
                    this.$nextTick(() => {
                        this.stockOrder.amount = 0
                        this.stockOrder.amount = this.stockOrder.currentAmount
                    })
                    this.$message.error(this.$t('Account.Transfer'))
                }
            },
            updateStockOrder(stock) {
                this.$refs[stock].validate((valid) => {
                    if (valid) {
                        if (this.stockOrder.sppCode == this.stockOrder.currentSppCode) {
                            this.$message.error(this.$t('Account.kwbnxt'))
                            return
                        }
                        let params = {
                            sppCode: this.stockOrder.sppCode,
                            sptId: this.stockOrder.sptId,
                            amount: this.stockOrder.amount,
                            batchNo: this.stockOrder.batchNo
                        }
                        let options = {
                            method: 'get',
                            url: this.$api.allotStock,
                            params: params
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.$message.success(this.$t('Account.tbcg'))
                                this.allotShow = false
                                this.getAllStock()
                            } else {
                                this.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            partStoreHouseList() {
                let params = {}
                if (this.fcCode != undefined && this.fcCode != '') {
                    params['fcCode'] = this.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.houseList = []
                        if (response.data != undefined && response.data != '') {
                            this.houseList = response.data
                        }
                    }
                })
            },
            sppCodeChange() {
                this.$forceUpdate()
            },
            sparePartPositionList(flag) {
                let queryParams = {}
                if (flag) {
                    this.stockOrder.sppCode = ''
                    if (this.stockOrder.strCode != undefined && this.stockOrder.strCode != '') {
                        queryParams['strCode'] = this.stockOrder.strCode
                    }
                }
                if (!flag) {
                    if (this.strCode != undefined && this.strCode != '') {
                        queryParams['strCode'] = this.strCode
                    }
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartPositionList,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            flag ? this.partPositionList = response.data : this.partPositionTOList = response.data
                        } else {
                            flag ? this.partPositionList = [] : this.partPositionTOList = []
                        }
                    }
                })
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.fcCode = this.userInfo.fcCode
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.getAllStock()
                    this.partStoreHouseList()
                })
            },
            getAllStock() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != '') {
                    queryParams['strCode'] = this.strCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.sppCode != undefined && this.sppCode != '') {
                    queryParams['sppCode'] = this.sppCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.spBrand != undefined && this.spBrand != '') {
                    queryParams['spBrand'] = this.spBrand
                }
                if (this.spModel != undefined && this.spModel != '') {
                    queryParams['spModel'] = this.spModel
                }
                if (this.spStatus != undefined && this.spStatus != '') {
                    queryParams['spStatus'] = this.spStatus
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllStock,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            async exportSparePartStock() {
                let queryParams = {}
                queryParams['language'] = this.$t('lang')
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != '') {
                    queryParams['strCode'] = this.strCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.sppCode != undefined && this.sppCode != '') {
                    queryParams['sppCode'] = this.sppCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.spBrand != undefined && this.spBrand != '') {
                    queryParams['spBrand'] = this.spBrand
                }
                if (this.spModel != undefined && this.spModel != '') {
                    queryParams['spModel'] = this.spModel
                }
                if (this.spStatus != undefined && this.spStatus != '') {
                    queryParams['spStatus'] = this.spStatus
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportSparePartStock,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = this.$t('Account.SpareStockInfo')  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            }
        }
    }
</script>

<style scoped>
/* ::v-deep .el-table--border th, td {
    border: 0.1px solid #868686 !important;
    border-right: none;
}

::v-deep .el-table__row td {
    border: 0.1px solid #868686 !important;
    border-right: none;
} */
</style>
